import { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars
import { Breadcrumb, Col, Row, Typography } from "antd";
// eslint-disable-next-line no-unused-vars
import { Link, useLocation, useParams } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import Paragraph from "antd/lib/typography/Paragraph";
// eslint-disable-next-line no-unused-vars
import PatientSelfMeasuresTable from "../../../components/Tables/PatientSelfMeasureTable";
import { translate } from "../../../locale";
import UserServices from "../../../services/UserServices";

// eslint-disable-next-line no-unused-vars
const { Title } = Typography;

const SelfMeasure = () => {
  const { username } = useParams();
  const location = useLocation();
  const [patientInfo, setPatientInfo] = useState(null);

  useEffect(() => {
    const fetchPatientInfo = async () => {
      try {
        const response = await UserServices.getProfile(username);
        if (response.status >= 200 && response.status < 300) {
          setPatientInfo(response.data.my_contact_info);
        }
      } catch (error) {
        console.error('fetchPatientInfo error:', error);
      }
    };
    fetchPatientInfo();
  }, [username]);

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl items-start my-10 mx-0 md:mx-10 px-4 md:px-0">
      <Row gutter={16} className="w-full">
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Automediciones")}</Breadcrumb.Item>
            {patientInfo && (
              <Breadcrumb.Item>
                {patientInfo.first_name} {patientInfo.last_name} - {username}
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
        </Col>
        <Col span={24} className="mt-6">
          <Title level={3} className="text-center !text-xl md:!text-3xl">
            {translate("Automediciones")}
          </Title>
        </Col>

        <Col span="24" className="mt-6">
          {location?.state?.subscriptions && (
            <PatientSelfMeasuresTable
              subscriptions={location.state.subscriptions}
            />
          )}
          {!location?.state?.subscriptions && (
            <Paragraph className="text-center">
              {translate("No encontramos suscripciones para este paciente.")}
            </Paragraph>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SelfMeasure;
